import dayjs from "dayjs";
import I18n from "common/i18n";
import Constants from "common/constant";
import { MockPiece } from "features/builder/pieceList";
import { IconArrowRight } from "features/creator/assets";
import { ProjectUser, TextBlueStroke } from "features/creator/elements";

const DEFAULT_USER_ICON = `${Constants.assetHost}/assets/users/icons/icon_default_kage01-1.png`;

const formatDate = (value: string | null) => (value ? dayjs(value).format("YYYY/MM/DD") : "");

// じゆうにつくる（creator）の ProjectAuthor と同じ見た目にする。構成部品（ProjectUser /
// TextBlueStroke / IconArrowRight）を creator から再利用する。
export const PieceAuthor = ({ piece }: { piece: MockPiece }) => {
  const isRemix = piece.copied_piece_id != null;

  if (!isRemix) {
    return (
      <div className="flex-col-center">
        <ProjectUser name={piece.author_name ?? ""} icon={piece.author_icon ?? DEFAULT_USER_ICON} />
        <div className="flex-row-el">
          <p className="type-text type-sm text-textcolor-black">{formatDate(piece.created_at)}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex-row-center">
      <div className="flex-col-center">
        <div>
          <TextBlueStroke text={I18n.t("MSG_CREATOR_APP_DETAIL_APP_AUTHOR")} />
        </div>
        <ProjectUser
          name={piece.original_author_name ?? piece.author_name ?? ""}
          icon={piece.original_author_icon ?? piece.author_icon ?? DEFAULT_USER_ICON}
        />
        <div className="flex-row-el">
          <p className="type-text type-sm text-textcolor-black">
            {formatDate(piece.original_piece_created_at ?? piece.created_at)}
          </p>
        </div>
      </div>

      <div className="flex-col-center w-[54px] h-[48px]">
        <IconArrowRight />
      </div>

      <div className="flex-col-center">
        <div>
          <TextBlueStroke text={I18n.t("MSG_CREATOR_APP_DETAIL_APP_EDITOR")} />
        </div>
        <ProjectUser name={piece.author_name ?? ""} icon={piece.author_icon ?? DEFAULT_USER_ICON} />
        <div className="flex-row-el">
          <p className="type-text type-sm text-textcolor-black">{formatDate(piece.updated_at)}</p>
        </div>
      </div>
    </div>
  );
};
